<template>
  <div>
    <router-link to="/activity">activity</router-link>|
    <router-link to="/template">template</router-link>|
    <router-link to="/lands">lands</router-link>|
    <router-link to="/onelink">onelink</router-link>|
    <router-link to="/clause">clause</router-link>|
    <router-link to="/native/guide">guide</router-link>|
    <router-link to="/native/exchangecode">exchangecode</router-link>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style></style>
